import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { updateShippingCategory } from "../../../../../services/Admin/ShippingCategoriesApi";
import { getAdminCountries } from "../../../../../services/Admin/CountriesApi";

const EditShippingCategoryDialog = ({ open, onClose, onSuccess, category, currentCountryId }) => {
  const [loading, setLoading] = useState(false);
  const [countriesLoading, setCountriesLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [name, setName] = useState("");
  const [cost, setCost] = useState("");
  const [countryId, setCountryId] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      fetchCountries();
      setName(category?.name || "");
      setCost(category?.cost || "");
      setCountryId(currentCountryId || "");
      setError("");
    }
  }, [open, category, currentCountryId]);

  const fetchCountries = async () => {
    setCountriesLoading(true);
    try {
      const res = await getAdminCountries();
      const data = res?.success ? res.data : res;
      setCountries(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to load countries", err);
    } finally {
      setCountriesLoading(false);
    }
  };

  const handleSubmit = async () => {
    setError("");

    if (!name.trim()) {
      setError("يرجى إدخال اسم الشريحة");
      return;
    }
    if (cost === "" || cost === null) {
      setError("يرجى إدخال التكلفة");
      return;
    }
    if (!countryId) {
      setError("يرجى اختيار الدولة");
      return;
    }

    const payload = {
      name: name.trim(),
      cost: Number(cost),
      country_id: Number(countryId),
    };

    setLoading(true);
    try {
      const res = await updateShippingCategory(category.id, payload);
      if (res?.success) {
        onSuccess?.();
        onClose();
      } else {
        setError(res?.message || "فشل تعديل الشريحة");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء التعديل");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>تعديل شريحة الشحن</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="اسم الشريحة"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
          />
          <TextField
            label="التكلفة"
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel>الدولة</InputLabel>
            <Select
              value={countryId}
              label="الدولة"
              onChange={(e) => setCountryId(e.target.value)}
              disabled={countriesLoading}
            >
              {countriesLoading ? (
                <MenuItem disabled>جارٍ التحميل...</MenuItem>
              ) : (
                countries.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.name_ar || c.name_en}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>

          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          إلغاء
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditShippingCategoryDialog;
